import api from '@/services/utils/base';
import store from '@/store';

export default class Landing {
  get(id: string) {
    return api.get(`landings/${id}`).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
  }

  getName(id: string) {
    return api.get(`landings/name/${id}`);
  }

  postCreate(payload: object) {
    return api.post('landings', payload).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
    .catch((err: any) => {
      return Promise.reject(err);
    });
  }

  getList(params?:any) {
    const newParams = {...params}
    const workspaceId = newParams.workspaceId
    delete newParams.workspaceId;
    return api
      .get('landings', {params:{
          ...newParams,
          workspaceIds:[...new Set([workspaceId,...store.getters.allPublicWorkspacesIds])]
        }})
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  putUpdate(id: string, payload: object) {
    return api.put(`landings/${id}`, payload);
  }

  delete(id: string) {
    return api.delete(`landings/${id}`);
  }

  postArchive(payload: object) {
    return api.post('landings/archive', payload);
  }

  postRestore(payload: object) {
    return api.post('landings/restore', payload);
  }

  postDuplicate(payload: object) {
    return api.post('landings/duplicate', payload);
  }

  getCount(payload: object) {
    return api.get('landings/count', payload);
  }

  import(data: any) {
    return api.post('landings/import', data);
  }

  bulkUpdate(workspaceId: string, payload: object) {
    return api.put(`/landings/workspace/${workspaceId}/bulk-update`, payload);
  }

  updateStoreCache({workspaceId, countryId}) {
    return api.get('landings', {
      params:{
        status:'active',
        limit:'200',
        columns:[ 'id', 'name', 'countryId', 'workspaceId', 'offers', 'url'],
        tagsOff:1,
        orderBy:'updated',
        orderDirection:'desc',
        workspaceIds:[...new Set([workspaceId,...store.getters.allPublicWorkspacesIds])],
        ...(countryId!==0 && {countryId})
      }
    }).then((res)=>{
      store.commit('updateLandingsCache', {
        workspaceId,
        countryId,
        data:res.data.payload
      });
      return Promise.resolve(res.data.payload);
    })
  }

  populateStoreCache() {
    return api.get('landings', {
      params:{
        status:'active',
        limit:'200',
        columns:[ 'id', 'name', 'countryId', 'workspaceId', 'offers', 'url'],
        tagsOff:1,
        orderBy:'updated',
        orderDirection:'desc'
      }
    }).then((res)=>{
      store.commit('populateLandingsCache', res.data.payload);
      return Promise.resolve(res.data.payload);
    })
  }
}
